'use strict';

angular.module('study.placeholders', [
    'study.ecrd'
]);
